import axios from 'axios';

const setupAxiosInterceptors = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  axios.defaults.baseURL = isDevelopment ? 'http://localhost:5000/api' : '/api';
  axios.defaults.withCredentials = true;

  axios.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        console.log('Unauthorized access, redirecting to login');
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
